import tokenStorageService from "../services/TokenStorageService";
import config from '../config';
import store from '../store';

/**
 * Class AuthInterceptors
 */
export default class AuthInterceptors {

    /**
     * Adds base interceptors to an AxiosInstance
     *
     * @param instance
     */
    static addAuthInterceptors (instance) {
        this._redirectToLoginOnUnauthenticated(instance);
        this._refreshAuthorizationToken(instance);
    }

    /**
     * Redirects the user to the login page, and removes the token if a
     * response code is 401
     *
     * @param {AxiosInstance} instance
     * @private
     */
    static _redirectToLoginOnUnauthenticated (instance) {
        instance.interceptors.response.use((response) => {
            return response;
        }, (response) => {
            if (response.status === 419) {
                store.dispatch('auth/setReferrer', window.location.pathname);
                store.dispatch('auth/unauthenticate', { level: 'info', text: 'signIn.inactivityNotice' });
            }
            if (response.status === 401) {
                store.dispatch('auth/unauthenticate', { level: 'warning', text: 'signIn.invalidNotice' });
            }
            return Promise.reject(response);
        });
    }

    /**
     * Refreshes the authorization token if a token is intercepted
     *
     * @param instance
     * @private
     */
    static _refreshAuthorizationToken (instance) {
        instance.interceptors.response.use((response) => {

            const refreshHeader = response.headers[config.http.GATEWAY_TOKEN_REFRESH_HEADER.toLowerCase()];

            if (refreshHeader) {
                tokenStorageService.set(refreshHeader);
            }

            return response;
        });
    }
}



// WEBPACK FOOTER //
// ./src/interceptors/AuthInterceptors.js